import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WTPFilterBatteryNoDDL } from '../../../../../../Components/CommonDDL/WTPFilterBatteryNoDDL';
import { BedMasterPostDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/WTPMasterData/BedMasterSlice';


export default function WTPBedNumberMasterPagePopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    const [IsOpen, setIsOpen] = useState(false)

    const [FilterBatteryNo, setFilterBatteryNo] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_FilterBatteryNoID : 0,
        Label: Flag === 'Update' ? rowData.filterBatteryNo : "Select...",
    })

    const [BedNumberTextField, setBedNumberTextField] = useState({
        bedNumber: Flag === 'Update' ? rowData.bedNumber : '',

    });

    const handleInputChange = (e) => {
        setBedNumberTextField({ ...BedNumberTextField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            M_WTP_BedMasterID: Flag === 'Update' ? rowData.m_wtP_BedMasterID : '0',
            M_WTP_FilterBatteryNoID: FilterBatteryNo.ID,
            BedNumber: BedNumberTextField.bedNumber,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
        }
        dispatch(BedMasterPostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Bed Number Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-12 col-lg-6">
                                    <WTPFilterBatteryNoDDL
                                        FilterBatteryNo={FilterBatteryNo}
                                        setFilterBatteryNo={setFilterBatteryNo}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Bed Number </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="bedNumber"
                                            name='bedNumber'
                                            value={BedNumberTextField.bedNumber}
                                            onChange={(e) => handleInputChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 py-lg-4">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}